import React from "react";
import Select from "react-select";
import { Label } from "reactstrap";

const daysOfWeek = [
  { value: "MO", label: "Mon" },
  { value: "TU", label: "Tue" },
  { value: "WE", label: "Wed" },
  { value: "TH", label: "Thu" },
  { value: "FR", label: "Fri" },
  { value: "SA", label: "Sat" },
  { value: "SU", label: "Sun" },
];

const DayOfWeekSelector = ({ value, onChange }) => {
  // Function to normalize the value for comparison
  const normalizeDay = (day) => {
    if (typeof day === 'string') {
      // Convert to uppercase and take first 2 letters
      return day.toUpperCase().substring(0, 2);
    }
    return day;
  };

  // Get selected options - check both value and label
  const selectedOptions = daysOfWeek.filter((day) => {
    const normalizedDayValue = normalizeDay(day.value);
    return value.some((selectedDay) => {
      const normalizedSelected = normalizeDay(selectedDay);
      return (
        normalizedSelected === normalizedDayValue ||
        normalizedSelected === day.label.toUpperCase().substring(0, 2) ||
        day.label.toLowerCase().includes(selectedDay.toLowerCase()) ||
        selectedDay.toLowerCase().includes(day.label.toLowerCase())
      );
    });
  });

  return (
    <div className="mb-2">
      <Label>Repeat on</Label>
      <Select
        isMulti
        options={daysOfWeek}
        value={selectedOptions}
        onChange={(opts) => onChange(opts.map((o) => o.value))}
        placeholder="Select days..."
        className="react-select"
      />
    </div>
  );
};

export default DayOfWeekSelector;